<template>
  <div class="col-12 offer-card">
    <div class="white-bg card-top border">
      <h2 class="title h3n my1 break-word">{{ product.name }}</h2>
      <span class="h4n block mb1">{{ offerInfo.name }}</span>
    </div>
    <div class="invert flex justify-end items-center card-bottom flex-wrap">
      <div class="flex">
        <h5 v-if="showApartirDe" class="mr3">À partir de</h5>
        <span :class="['m0 ml1 bold', { 'crossed h2': canShowPromotion, 'ucpa-CartMember-total': !canShowPromotion}]">
          <span v-if="priceWithDecimals(offerInfo.detail.lowest_price) > 0">
            {{ priceWithDecimals(offerInfo.detail.lowest_price) }}€
          </span>
          <span v-else class="h2">
            OFFERT
          </span>
        </span>
        <span v-if="canShowPromotion" class="ucpa-CartMember-total bold m0 ml1">{{ priceWithDecimals(offerInfo.detail.lowest_price_promo) }}€</span>
        <span v-if="isRecurring" class="h3 ml1">/ mois</span>
      </div>
    </div>
  </div>
</template>
<script>
import { isWithinInterval, format } from 'date-fns';

import { priceWithDecimals } from '@/utils/labels';

export default {
  data () {
    return {
      product: this.$store.state.product,
      offerInfo: this.$store.state.offerInfo
    };
  },
  computed: {
    showApartirDe () {
      const price = this.priceWithDecimals(this.offerInfo.detail.lowest_price);
      const pricePromo = this.priceWithDecimals(this.offerInfo.detail.lowest_price_promo);
      return price > 0 || pricePromo > 0;
    },
    canShowPromotion () {
      if (this.offerInfo.detail.lowest_price_promo && parseFloat(this.offerInfo.detail.lowest_price_promo) < parseFloat(this.offerInfo.detail.lowest_price)) {
        const now = new Date();
        const { prices } = this.offerInfo.detail;

        let day_week = format(now, 'ee');

        if (day_week === 1) {
          day_week = 7;
        } else {
          day_week -= 1;
        }

        return prices.some(price => price.promotions.some(promo => {
          const startDate = new Date(promo.start_date);
          const endDate = new Date(promo.end_date);

          const isBetween = isWithinInterval(now, {
            start: startDate,
            end: endDate
          });

          if (isBetween /* && promo.quantity_remaining > 0 */ && (promo.week_day === 0 || promo.week_day === day_week)) { // TODO uncomment when correctly receiving quantity remaining
            return true;
          }
          return false;
        }));
      }
      return false;
    },
    isRecurring () {
      return this.offerInfo.detail.recurring;
    }
  },
  methods: { priceWithDecimals }
};
</script>

<style lang="scss">
  .offer-card {
    .card-top {
      padding:  2rem 4rem;

    }
    .card-bottom {
      padding: 1rem 4rem;
    }
  }
  @media (max-width: 40rem) {
    .offer-card {
      .card-top {
        padding:  1rem 2rem;

      }
      .card-bottom {
        padding: 1rem 2rem;
      }
    }
  }
</style>
